import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import * as React from 'react';
import { ContentLoader } from '@/components/ui/loaders';
import type { useIsAuthenticated } from '@/services/auth';
import { ErrorPage } from './+error.page';
import { NotFoundPage } from './+not-found';

type RouterContext = {
  auth: ReturnType<typeof useIsAuthenticated>;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  notFoundComponent: NotFoundPage,
  component: RootComponent,
  wrapInSuspense: true,
  errorComponent: ({ error }) => <ErrorPage error={error as any} />,
  pendingComponent: () => <ContentLoader show />,
});

function RootComponent() {
  return (
    <React.Fragment>
      <HeadContent />
      <Outlet />
    </React.Fragment>
  );
}
